/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_PROCESS_STATUS,
  LOAD_PROCESS_STATUS_SUCCESS,
  LOAD_PROCESS_STATUS_ERROR,
  LOAD_EMPLOYEE_REQUEST,
  LOAD_EMPLOYEE_REQUEST_SUCCESS,
  LOAD_EMPLOYEE_REQUEST_ERROR,
  UPDATE_EMPLOYEE_REQUEST,
  UPDATE_EMPLOYEE_REQUEST_SUCCESS,
  UPDATE_EMPLOYEE_REQUEST_ERROR,
  ADD_REQUEST,
  ADD_REQUEST_SUCCESS,
  ADD_REQUEST_ERROR
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

/**
 * @param {integer} id
 */
export function loadEmployeeRequest(searchFilter) {
  return {
    type: LOAD_EMPLOYEE_REQUEST,
    searchFilter,
  }
}

/**
 * @param {object}
 * @param {object}
 */
export function loadEmployeeRequestSuccess(employee_request) {
  return {
    type: LOAD_EMPLOYEE_REQUEST_SUCCESS,
    employee_request,
  }
}

/**
 * @param {string} error
 */
export function loadEmployeeRequestError(error) {
  return {
    type: LOAD_EMPLOYEE_REQUEST_ERROR,
    error,
  }
}
/**
 * @param {integer} id
 */
export function loadProcessStatus(mode) {
  return {
    type: LOAD_PROCESS_STATUS,
    mode,
  }
}

/**
 * @param {object}
 * @param {object}
 */
export function loadProcessStatusSuccess(process_status) {
  return {
    type: LOAD_PROCESS_STATUS_SUCCESS,
    process_status,
  }
}

/**
 * @param {string} error
 */
export function loadProcessStatusError(error) {
  return {
    type: LOAD_PROCESS_STATUS_ERROR,
    error,
  }
}

/**
 * @param {integer} id
 */
 export function updateEmployeeRequest(employeeUpdate) {
  return {
    type: UPDATE_EMPLOYEE_REQUEST,
    employeeUpdate,
  }
}

/**
 * @param {object}
 * @param {object}
 */
export function updateEmployeeRequestSuccess(employeeUpdate) {
  return {
    type: UPDATE_EMPLOYEE_REQUEST_SUCCESS,
    employeeUpdate,
  }
}

/**
 * @param {string} error
 */
export function updateEmployeeRequestError(error) {
  return {
    type: UPDATE_EMPLOYEE_REQUEST_ERROR,
    error,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}
//addRequest
export function addRequest(request_details) {
  return {
    type: ADD_REQUEST,
    request_details,
  }
}

/**
 * @param {object}
 * @param {object}
 */
export function addRequestSuccess(employeeUpdate) {
  return {
    type: ADD_REQUEST_SUCCESS,
    employeeUpdate,
  }
}

/**
 * @param {string} error
 */
export function addRequestError(error) {
  return {
    type: ADD_REQUEST_ERROR,
    error,
  }
}

const actions = {
  loadEmployeeRequest,
  loadEmployeeRequestSuccess,
  loadEmployeeRequestError,
  loadProcessStatus,
  loadProcessStatusSuccess,
  loadProcessStatusError,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  updateEmployeeRequest,
  updateEmployeeRequestSuccess,
  updateEmployeeRequestError,
  addRequest,
  addRequestSuccess,
  addRequestError
}

export default actions
